"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class NotificationClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.version = 'v2';
    }
    markAlertNotificationsAsSeen(projectId, alertId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}/users/me/alerts/${alertId}/notifications/seen`;
            yield this.httpPut(url);
        });
    }
    markNotificationsAsSeen(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}/users/me/notifications/seen`;
            yield this.httpPut(url);
        });
    }
    getNotifications(projectId, params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}/users/me/notifications?${this.getQueryString(params)}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getNotificationsByAlertId(projectId, alertId, params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}/alerts/${alertId}/notifications?${this.getQueryString(params)}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getById(projectId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}/users/me/notifications/${id}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getUnseenNotificationsCount(projectId, hasTriggered = true) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}/users/me/notifications/count?${this.getQueryString({
                seen: false,
                hasTriggered,
            })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    deleteNotifications(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}/users/me/notifications`;
            yield this.httpDelete(url);
        });
    }
}
exports.NotificationClient = NotificationClient;
//# sourceMappingURL=notification.client.js.map